import * as z from "zod";
import { create } from "zustand";

export const MaintenanceStatus = z.object({
  enabled: z.boolean(),
  message: z.string(),
});

type MaintenanceStatus = z.infer<typeof MaintenanceStatus>;

type MaintenanceState = MaintenanceStatus & {
  lastFetchedAt: number;
};

const useMaintenanceStore = create<MaintenanceState>(() => ({
  enabled: false,
  message: "",
  lastFetchedAt: 0,
}));

export default useMaintenanceStore;
